export default "__VITE_ASSET__DOLiMgGR__"